<template>
    <div>
        <card title="Provider Web Management">
            <b-row>
                <b-col class="col-4">
                    <Card plain>
                        <h6>Announcements</h6>

                        <card plain>
                            <b-form-textarea v-model="announcement.body" class="textarea-autosize" placeholder="Enter new Announcement" rows="8"
                                max-rows="8" />
                            <br />
                            <b-row>
                                <b-col>
                                    <vue-dropzone id="dropzone" ref="myVueDropzone" :options="dropzoneOptions"
                                        @vdropzone-success="dropzoneUploadSuccess"
                                        @vdropzone-sending="dropzoneSending"
                                        @vdropzone-error="dropzoneError" />
                                </b-col>
                            </b-row>
                            <b-button variant="success" block @click="SubmitNewAnnouncement">
                                <strong>
                                    Send Announcement
                                </strong>
                            </b-button>
                        </card>

                        <div class="mb-1">
                            <a href="#" @click.prevent="showPreviousAnnouncements = !showPreviousAnnouncements">
                                <i :class="{ 'fa fa-fw': true, 'fa-chevron-right': true, 'fa-rotate-90': showPreviousAnnouncements }"
                                    aria-hidden="true" style="transition: all .2s;"></i>
                                <strong>Previous Announcements</strong>
                            </a>
                        </div>

                        <b-collapse :visible="showPreviousAnnouncements">
                            <Card plain v-for="a in announcements" :key="a.id" class="mb-2">
                                <b-row>
                                    <b-col>
                                        {{ a.body }}
                                        <b-img :src="a.imageUrl" />
                                    </b-col>
                                </b-row>
                            </Card>
                        </b-collapse>

                    </Card>
                </b-col>
                <b-col>
                    <Card plain>
                        <h6>Practice Management</h6>
                        <b-row>
                            <b-col>
                                <fg-input class="mt-2" v-model="newPracticeName" placeholder="New Practice Name (required)" />
                            </b-col>
                            <b-button variant="success" @click="SubmitNewPractice" class="mr-3">
                                Add Practice
                            </b-button>
                        </b-row>
                        <b-table id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                            :items="practices" @row-clicked="selectPractice" :current-page="pageNumber"
                            :per-page="pageSize" />
                        <BottomPagerBar v-model="pageNumber" :total-rows="practices.length" item-name="practice"
                            :current-page="pageNumber" :per-page="pageSize" show-page-size-selector
                            @change-page-size="pageSize = $event" />
                    </Card>
                </b-col>
            </b-row>
        </card>

        <b-modal id="doctorSearchModal" title="Prescriber Search" size="xl" @ok="selectDoc">
            <NameSearchComponent v-model="displayName" :named-person="doctor" search-mode
                @person-update="personUpdate" />
        </b-modal>

        <b-modal id="practiceDetailModal" title="Practice Info" size="xl" @hide="getPractices">
            <b-row>
                <b-col class="col-3">
                    <Card>
                        <b>Name: </b>{{ selectedPractice.name }}<br />
                        <b>Doctor Count: </b> {{ practiceDoctors.length }}<br />
                        <b>User Count: </b> {{ practiceUsers.length }}<br />

                        <b-button variant="success" size="sm" @click="editModeChange('user')">Add User</b-button>
                        <b-button variant="info" size="sm" @click="editModeChange('doctor')">Add Doctor</b-button>
                    </Card>

                    <Card v-if="editMode == 'user'">
                        <h6>{{ editMode }} Creation</h6>
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.email" placeholder="Email (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.firstName" placeholder="First Name (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.lastName" placeholder="Last Name (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.phoneNumber"
                            placeholder="Phone Number (+1XXXXXXXXXX) (required)" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.address1" placeholder="Address Line 1" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.address2" placeholder="Address Line 2" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.city" placeholder="City" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.state" placeholder="State" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.postalCode" placeholder="Postal Code" />
                        <fg-input v-if="editMode == 'user'" v-model="newPerson.npiNumber" placeholder="NPI" />

                        <label v-if="editMode == 'user'">
                            <input type="checkbox" v-model="newPerson.canPrescribe">
                            &nbsp;Can Prescribe
                            </input>
                        </label>

                        <div class="pt-1">
                            <b-button variant="success" size="sm" @click="submitEdit" block>
                                Create
                            </b-button>
                        </div>
                    </Card>
                </b-col>
                <b-col>
                    <h6>Users</h6>
                    <b-spinner v-if="loadingUsers" />
                    <b-table v-else id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                        :items="practiceUsers" :fields="userFields">
                        <template #cell(resend)="data">
                            <b-icon icon="envelope-fill" v-b-tooltip.hover title="Resend Welcome Email" variant="info"
                                style="cursor: pointer" @click="resendWelcomeEmail(data.item)">
                            </b-icon>
                        </template>
                        <template #cell(remove)="data">
                            <b-icon icon="x-circle-fill" v-b-tooltip.hover title="Remove" variant="danger"
                                style="cursor: pointer" @click="removeUser(data.item)">
                            </b-icon>
                        </template>
                    </b-table>

                    <h6>Doctors</h6>
                    <b-spinner v-if="loadingDoctors" />
                    <b-table v-else id="practices-table" style="cursor:pointer" striped responsive="true" sort-icon-left
                        :items="practiceDoctors" :fields="doctorFields">
                        <template #cell(remove)="data">
                            <b-icon icon="x-circle-fill" v-b-tooltip.hover title="Remove" variant="danger"
                                style="cursor: pointer" @click="removeDoctor(data.item)">
                            </b-icon>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script lang="ts">
import Axios, { AxiosError } from 'axios';
import { Component, Mixins } from 'vue-property-decorator';
import DisableAutocompleteMixin from '@/mixins/DisableAutocompleteMixin';
import Vue2Dropzone from 'vue2-dropzone';
import SearchComponent from '@/components/SearchComponent.vue';
import EnumSelector from '@/components/EnumSelector.vue';
import Checkbox from "@/components/Inputs/Checkbox.vue";
import NewClearSaveButtons from '@/components/NewClearSaveButtons.vue';
import NameSearchComponent from '@/components/NameSearchComponent.vue';
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import { PracticeResult, ProviderWebPerson, AnnouncementResult, Announcement } from "@/models/ProviderWeb";
import { Prescriber } from "@/models/Prescriber";
import BottomPagerBar from '@/components/BottomPagerBar.vue';

@Component({
    name: 'ProviderWebPage',
    components: {
        SearchComponent,
        Checkbox,
        NewClearSaveButtons,
        EnumSelector,
        NameSearchComponent,
        "VueDropzone": Vue2Dropzone,
        BottomPagerBar
    },
})
export default class ProviderWebPage extends Mixins(DisableAutocompleteMixin) {

    protected practices: PracticeResult[] = [];
    private selectedPractice: PracticeResult = {} as PracticeResult;
    protected practiceDoctors: ProviderWebPerson[] = [];
    protected practiceUsers: ProviderWebPerson[] = [];
    private editMode: string | null = null;
    private newPerson: ProviderWebPerson = {} as ProviderWebPerson;
    private doctor: Prescriber = new Prescriber();
    private displayName = "";
    private newPracticeName = "";
    private announcement: AnnouncementResult = {} as AnnouncementResult;
    protected announcements: Announcement[] = [];

    protected pageNumber = 1;
    protected pageSize = 50;

    protected loadingUsers = false;
    protected loadingDoctors = false;

    protected showPreviousAnnouncements = false;

    private userFields = [
        { key: 'username', sortable: true },
        { key: 'email', sortable: true },
        { key: 'canPrescribe', sortable: true, formatter: (value: boolean) => value ? "✔️" : "" },
        { key: "resend", label: "" },
        { key: "remove", label: "" },
    ];

    private doctorFields = [
        { key: 'name', sortable: true },
        { key: 'npiNumber', sortable: true },
        { key: "remove", label: "" },
    ];

    created() {
        this.getPractices();
        this.getAnnouncements();
    }

    // dropzone
    // properties
    get dropzoneOptions(): any {
        return {
            url: `${Axios.defaults.baseURL}/image/ProviderWeb`,
            thumbnailWidth: 150,
            withCredentials: true,
            paramName: 'images',
            maxFiles: 1,
            addRemoveLinks: true,
        };
    }

    // events
    dropzoneSending(file: any, xhr: XMLHttpRequest, _formData: FormData) {
        const authHeader = Axios.defaults.headers["Authorization"]?.toString() ?? "";
        xhr.setRequestHeader("Authorization", authHeader);
    }

    dropzoneUploadSuccess(file: any, response: any) {
        this.announcement.imageUrl = response;
    }

    dropzoneError(file: any, message: any, xhr: any) {
        console.error("Dropzone upload error:", { file: file.name, message, status: xhr?.status, response: xhr?.responseText });
        this.$notification(NotificationOptions.error(`Image upload failed: ${typeof message === 'string' ? message : message?.message || 'Unknown error'}`));
    }

    selectPractice(practice: any) {
        this.$bvModal.show('practiceDetailModal');
        this.selectedPractice = practice;

        this.getPracticeUsers();
        this.getPracticeDoctors();
    }

    async getAnnouncements() {
        try {
            const response = await Axios.get<Announcement[]>('api/ProviderWeb/Announcement');
            this.announcements = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async getPractices() {
        try {
            let response = await Axios.get<PracticeResult[]>('api/ProviderWeb/Practices/All');
            this.practices = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async getPracticeUsers() {
        try {
            this.loadingUsers = true;
            this.practiceUsers = [];
            const response = await Axios.get(`/ProviderWeb/Practices/Users/${this.selectedPractice.id}`);
            this.practiceUsers = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingUsers = false;
        }
    }

    async getPracticeDoctors() {
        try {
            this.loadingDoctors = true;
            this.practiceDoctors = [];
            const response = await Axios.get(`/ProviderWeb/Practices/Doctors/${this.selectedPractice.id}`);
            this.practiceDoctors = response.data;
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        } finally {
            this.loadingDoctors = false;
        }
    }

    editModeChange(chosenMode: string) {
        if (chosenMode != this.editMode) {
            this.newPerson = {} as ProviderWebPerson;
        }
        this.editMode = chosenMode;
        if (chosenMode == 'doctor') {
            this.$bvModal.show('doctorSearchModal');
        }

    }

    async submitEdit() {
        if (this.editMode != 'user') return;

        if (!this.newPerson.email?.trim()) {
            this.$notification(NotificationOptions.error("Email is required"));
            return;
        }

        if (!this.newPerson.firstName?.trim()) {
            this.$notification(NotificationOptions.error("First Name is required"));
            return;
        }

        if (!this.newPerson.lastName?.trim()) {
            this.$notification(NotificationOptions.error("Last Name is required"));
            return;
        }

        if (!this.newPerson.phoneNumber?.trim()) {
            this.$notification(NotificationOptions.error("Phone Number is required. Format must be +1XXXXXXXXXX"));
            return;
        }

        if (this.newPerson.canPrescribe) {
            if (!this.newPerson.npiNumber?.trim()) {
                this.$notification(NotificationOptions.error("NPI is required when 'Can Prescribe' is selected"));
                return;
            }

            if (!/^\d{10}$/.test(this.newPerson.npiNumber.trim())) {
                this.$notification(NotificationOptions.error("NPI must be exactly 10 digits"));
                return;
            }
        }

        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/CreateUser`, this.newPerson);
            this.newPerson = {} as ProviderWebPerson;
            this.getPracticeUsers();
            this.$notification(NotificationOptions.success("Created new user"));
        } catch (error) {
            const err = error as AxiosError;
            const errorMessage = err.response?.data || err.message || "Failed to create user";
            this.$notification(NotificationOptions.error(errorMessage));
        }
    }

    async selectDoc() {
        this.newPerson.npiNumber = this.doctor.npiNumber;
        this.newPerson.practiceId = this.selectedPractice.id;
        try {
            await Axios.post(`/ProviderWeb/Practices/AddDoctor`, this.newPerson);
            await this.getPracticeDoctors();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    personUpdate(value: any) {
        this.doctor = value;
    }

    async resendWelcomeEmail(user: any) {
        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/ResendWelcomeEmail`, {
                username: user.username
            });
            this.$notification(NotificationOptions.success("Welcome email resent successfully"));
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async removeUser(user: any) {
        console.log(user);
        try {
            await Axios.post(`/ProviderWeb/Practices/${this.selectedPractice.id}/DeleteUser`, user);
            await this.getPracticeUsers();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async removeDoctor(doctor: any) {
        doctor.practiceId = this.selectedPractice.id;
        try {
            await Axios.post(`/ProviderWeb/Practices/DeleteDoctor`, doctor);
            await this.getPracticeDoctors();
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
    }

    async SubmitNewPractice() {
        if (!this.newPracticeName?.trim()) {
            this.$notification(NotificationOptions.error("Practice Name Required"));
            return;
        }

        try {
            await Axios.post(`/ProviderWeb/Practices/New/${this.newPracticeName}`);
            await this.getPractices();
            this.newPracticeName = "";
        } catch (error) {
            const err = error as AxiosError;
            const errorMessage = err.response?.data || err.message || "Failed to create practice";
            this.$notification(NotificationOptions.error(errorMessage));
        }
    }

    async SubmitNewAnnouncement() {
        try {
            await Axios.post(`/ProviderWeb/Announcement`, this.announcement);
            this.announcement = {} as AnnouncementResult;

            // Clear the dropzone after successful submission
            const dropzone: any = this.$refs.myVueDropzone;
            if (dropzone) {
                dropzone.removeAllFiles();
            }

            this.$notification(NotificationOptions.success("Posted announcement"));
        } catch (error) {
            this.$notification(NotificationOptions.error(error));
        }
        await this.getAnnouncements();
    }
} // close export of class
</script>

<style scoped></style>
